export default "__VITE_ASSET__abb833f2__"